var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.609985,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F2C94C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1637 19.5025C22.1634 19.9629 22.5365 20.336 22.997 20.3358C23.4574 20.3356 23.8309 19.9621 23.8311 19.5017L23.8343 13.6242C23.8345 13.1637 23.4614 12.7906 23.001 12.7909L17.097 12.7858C16.6366 12.786 16.2631 13.1595 16.2629 13.6199C16.2627 14.0804 16.6358 14.4535 17.0962 14.4533L20.9874 14.4592L12.3935 23.0539C12.0859 23.3615 12.1003 23.8747 12.4257 24.2002C12.7512 24.5256 13.2644 24.54 13.572 24.2324L22.1659 15.6377L22.1637 19.5025Z",
    fill: "#4060EA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightArrow);
export default __webpack_public_path__ + "static/media/TopRightArrow.ee923a3ed810ff8eaf5eaf0356b3010d.svg";
export { ForwardRef as ReactComponent };